<span
  class="kyb-status-chip"
  [ngClass]="colourClass()"
  [matTooltip]="tooltip"
  matTooltipPosition="below"
>{{ status.value }}</span>
